import React from 'react';

/**
 * React context for the ExpansionPanel family
 */
export default /*#__PURE__*/React.createContext({
  disabled: false
});